import React from 'react'
import { CloseIconLight, IcoMoon, InfoIconOutline } from '@usap/uicomponents'
import {
  StyledCloseButton,
  StyledIconWrapper,
  StyledText,
  StyledTextWrapper,
  StyledWrapper,
} from './WarningWmo.css'

export default function WarningWmo({
  message,
  onClose,
}) {
  return (
    <StyledWrapper>
      <StyledTextWrapper>
        <StyledIconWrapper>
          <IcoMoon
            size="20px"
            icon={InfoIconOutline}
            color="#3E3E47"
            viewBox="0 0 20 20"
          />
        </StyledIconWrapper>
        <StyledText>{message}</StyledText>
      </StyledTextWrapper>
      {onClose && (
      <StyledCloseButton type="button" onClick={onClose}>
        <IcoMoon
          icon={CloseIconLight}
          color="#3E3E47"
          size="16px"
          viewBoxProp="0 0 16 16"
        />
      </StyledCloseButton>
      )}
    </StyledWrapper>
  )
}
